import React from "react";

import appStore, { actions as appActions } from "../../core/app.store";

class NavbarToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: appStore.getState().app.menuVisible !== false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.unsubscribe = appStore.subscribe(this.onChange);
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  onChange() {
    this.setState({ menuVisible: appStore.getState().app.menuVisible !== false });
  }

  handleClick(e) {
    e.preventDefault();
    appActions.toggleSidebar();
  }

  render() {
    const toggle_class = this.state.menuVisible ? "sidebar-open" : "sidebar-close";

    return (
      <nav className="nav">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={this.handleClick}
          className={`nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-inline d-lg-none text-center ${toggle_class}`}
        >
          <i className="material-icons">&#xE5D2;</i>
        </a>
      </nav>
    );
  }
}

export default NavbarToggle;
